export default (val = "", required = false, type = "text", disabled) => {
  const { $translate } = useNuxtApp();

  let error = false;
  let text = null;
  // is empty
  if (
    required &&
    (type === "text" || (type === "file" && !disabled)) &&
    typeof val === "string" &&
    !val.trim().length
  ) {
    error = true;
    text = $translate("validate", "empty_field");
  }

  if (required && type === "password" && typeof val === "string") {
    // Password must be longer than 3 and shorter than 12
    if (val.trim().length < 3 || val.length > 12) {
      error = true;
      if (!val.trim().length) {
        text = $translate("validate", "empty_field");
      } else {
        text = $translate("validate", "password_length");
      }
    }
  }

  // email
  if (required && type === "email") {
    const test_email =
      /^([a-zA-Z0-9_.-])+@([a-zA-Z0-9_.-])+\.([a-zA-Z])+([a-zA-Z])+/;
    if (!val.length || val === "" || !test_email.test(val)) {
      error = true;
      if (!val.length || val === "") {
        text = $translate("validate", "empty_field");
      } else {
        text = $translate("validate", "incorrect_email");
      }
    }
  }

  if (
    required &&
    type === "checkbox" &&
    ((typeof val === "string" && !val.trim().length) || !val)
  ) {
    error = true;
    text = $translate("validate", "empty_field");
  }

  return { error, text };
};
